import React from 'react';
var VeltCommentText = function (props) {
    var children = props.children, annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId;
    return (React.createElement("velt-comment-text", { "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId }, children));
};
export default VeltCommentText;
